import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconThumbUpAltSvg } from "./IconThumbUpAltSvg.mjs";
const IconThumbUpAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconThumbUpAltSvg, ...iconProps });
};
export {
  IconThumbUpAlt
};
